<template>
  <div data-name="老师列表">
  	<div class="filter-inline-panel cle">
          <div class="list-opinion fr">
	        <!-- <el-button type="primary" size="mini" @click="$router.back(-1)">{{$t('index.return')}}</el-button> -->
          </div>
        </div>
    <el-table :data="list" border size="mini">
      <el-table-column prop="first_name" align="center" :label="$t('teacher_apply.first_name')"></el-table-column>
      <el-table-column prop="last_name" align="center" :label="$t('teacher_apply.last_name')"></el-table-column>
      <el-table-column prop="email" align="center" :label="$t('teacher_apply.email')"></el-table-column>
      <el-table-column prop="phone" align="center" :label="$t('teacher_apply.phone')"></el-table-column>
      <el-table-column prop="address" align="center" :label="$t('teacher_apply.address')"></el-table-column>
      <!-- <el-table-column prop="course" align="center" :label="$t('teacher_apply.course')" :formatter="course_f"></el-table-column> -->
      <el-table-column prop="create_time" align="center" :label="$t('teacher_apply.date')">
				<template slot-scope="{row}">{{getTime_us(row.create_time,'mmddyyyyampm')}}</template>
      </el-table-column>
      <el-table-column :label="$t('index.operation')" width="280" align="center" fixed="right">
        <template slot-scope="scope">
          <el-button size="mini" type="primary" v-if="hasBtn('del')" @click="info(scope.row)">{{$t('index.info')}}</el-button>
          <el-button size="mini" type="danger" v-if="hasBtn('del')" @click="del(scope.row)">{{$t('index.del')}}</el-button>
          <div v-if="scope.row.file||scope.row.word_file" style="margin-top:10px">
	          <el-button size="mini" type="primary" v-if="hasBtn('file')&&scope.row.file" @click="fujian(scope.row.file)">{{$t('teacher_apply.file')}}</el-button>
	          <el-button size="mini" type="primary" v-if="hasBtn('file')&&scope.row.word_file" @click="fujian(scope.row.word_file)">{{$t('teacher_apply.word_file')}}</el-button>
          </div>
        </template>
      </el-table-column>
    </el-table>
    <div class="page-pagination">
      <el-pagination  align="right" small background :hide-on-single-page="false" @size-change="handleSizeChange" @current-change="handleCurrentChange" :current-page="pages.page" :page-sizes="[10, 20, 30, 40, 50, 100]" :page-size="pages.perpage" layout="total, prev, pager, next, sizes, jumper" :total="pages.count" :pager-count="5"></el-pagination>
    </div>
	<el-dialog :title="$t('index.info')" :close-on-click-modal="false" :visible.sync="editForm_is" width="1000px">
		<el-descriptions border>
			<el-descriptions-item :label="$t('teacher_apply.first_name')">{{editForm.first_name}}</el-descriptions-item>
			<el-descriptions-item :label="$t('teacher_apply.last_name')">{{editForm.last_name}}</el-descriptions-item>
			<el-descriptions-item :label="$t('teacher_apply.email')">{{editForm.email}}</el-descriptions-item>
			<el-descriptions-item :label="$t('teacher_apply.phone')">{{editForm.phone}}</el-descriptions-item>
			<el-descriptions-item :label="$t('teacher_apply.address')">{{editForm.address}}</el-descriptions-item>
		</el-descriptions>
		<el-descriptions border :column="1">
			<el-descriptions-item :label="$t('teacher_apply.course')">{{editForm.course | course_f(this_)}}</el-descriptions-item>
			<el-descriptions-item :label="$t('teacher_apply.history')">{{editForm.history}}</el-descriptions-item>
			<el-descriptions-item :label="$t('teacher_apply.style')">{{editForm.style}}</el-descriptions-item>
			<el-descriptions-item :label="$t('teacher_apply.resume')">{{editForm.resume}}</el-descriptions-item>
		</el-descriptions>
	</el-dialog>
  </div>
</template>
<script>
export default {
	data() {
		return {
			this_:this,
			list: [],
			pages: {
				page: 1,
				count: 100,
				perpage: 50,
			},
			editForm:{},
			editForm_is:false,
			course_data:[],
		}
	},
	// 初始事件
	mounted: function () {
		this.config();
		this.init();
	},
	// 事件
	methods: {
		config(){
			var this_ = this;
			var url = "cateOption";
			this_.$post(url, {}).then((res) => {
				this_.course_data=res.show;
			})
		},
		// 初始化
		init() {
			var this_ = this;
			var url = "teacherApply";
			var datas = {
				page:this_.pages.page,
				num:this_.pages.perpage,
			};
			this_.$post(url, datas).then((res) => {
				this_.list = res.list;
				this_.pages.count = res.sum;
			})
		},
		info(data){
			this.editForm_is=true;
			this.editForm=data;
			console.log(data)
		},
		course_f(w,s,d){
			var this_=this;
			var list=this_.course_data;
			var name='';
			if (list.length>0) {
				list.forEach(function(e,i) {
					if (d.indexOf(e.id)!=-1) {
						if (name=='') {
							name=this_.lang=='cn'?e.name_cn:e.name;
						}else{
							name+=','+(this_.lang=='cn'?e.name_cn:e.name);
						}
					}
				});
			}
			return name;
		},
		// 删除
		del(data) {
			var this_ = this;
			var url = "deleteTeacherApply";
			var datas = {
				id: data.id
			};
			this_.$confirm(this_.$t('index.confirm_delete'), this_.$t('index.tips')).then(() => {
				this_.$post(url, datas).then((res) => {
					this_.$message.success(this_.$t('index.delete_success'));
					this_.init();
				})
			}).catch(() => {});
		},
		fujian(file){
			if (file) {
				window.open(file);
			}
		},
		// 分页每页显示几条
		handleSizeChange(val) {
			var pages = this.pages;
			pages['perpage'] = val;
			this.pages = pages;
			this.init();
		},
		// 切换分页
		handleCurrentChange(val) {
			var pages = this.pages;
			pages['page'] = val;
			this.pages = pages;
			this.init();
		}
	},
	// 过滤器
	filters: {
		course_f(v,this_){
			var list=this_.course_data;
			var name='';
			if (list.length>0&&v) {
				list.forEach(function(e,i) {
					if (v.indexOf(e.id)!=-1) {
						if (name=='') {
							name=this_.lang=='cn'?e.name_cn:e.name;
						}else{
							name+=','+(this_.lang=='cn'?e.name_cn:e.name);
						}
					}
				});
			}
			return name;
		},
	}
}
</script>
<style scoped>
.filter-inline-panel {
	margin-bottom: 22px;
}
.page-pagination {
	padding: 20px 10px; 
}
</style>
<style>
	.el-descriptions-item__label.is-bordered-label{
		width: 100px;
	}
</style>



// WEBPACK FOOTER //
// src/views/teacher/apply.vue